export default [
    {
        id: '0',
        icon: 'iconfont icon-home',
        name: '首页',
        url: '/home',
        parentUuid:'',
        path:'/home'
    },
    {
        id: '1',
        icon: 'iconfont icon-jiaohuan',
        name: '交易',
        parentUuid:'',
        children: [
            {
                id: '10',
                name: '订单管理',
                parentUuid:'1',
                children: [
                    {
                        id: '100',
                        name: '打印订单',
                        url: '/printOrderList',
                        path:'/printOrderList',
                        parentUuid:'10',
                    },
                    {
                        id: '101',
                        name: '商城订单',
                        url: '/mallOrderList',
                        path:'/mallOrderList',
                        parentUuid:'10',
                    },
                    {
                        id: '102',
                        name: '设计订单',
                        url: '/designOrderList',
                        path:'/designOrderList',
                        parentUuid:'10',
                    },
                    {
                        id: '103',
                        name: '模型订单',
                        url: '/modelOrderList',
                        path:'/modelOrderList',
                        parentUuid:'10',
                    },
                    {
                        id: '104',
                        name: '服务订单',
                        url: '/severOrderList',
                        path: '/severOrderList',
                        parentUuid:'10',
                    },
                    {
                        id: '105',
                        name: '软件订单',
                        url: '/softwareOrderList',
                        path: '/softwareOrderList',
                        parentUuid:'10',
                    },
                    {
                        id: '106',
                        name: '积分订单',
                        url: '/integralOrderList',
                        path: '/integralOrderList',
                        parentUuid:'10',
                    },
                    // {
                    //     id: '107',
                    //     name: '集采订单',
                    //     url: '/collectOrderList'
                    // }
                ]
            },
            {
                id: '11',
                name: '评价管理',
                url: '/evaluationManagement',
                path: '/evaluationManagement',
                parentUuid:'1',
            },
            {
                id: '12',
                name: '收货地址',
                url: '/tradShippAddress',
                path: '/tradShippAddress',
                parentUuid:'1',
            },

            {
                id: '13',
                name: '合同管理',
                parentUuid:'1',
                children: [
                    {
                        id: '130',
                        name: '合同管理',
                        url: '/contractManage',
                        path: '/contractManage',
                        parentUuid:'13',
                    },
                    {
                        id: '132',
                        name: '模板管理',
                        url: '/moduleManage',
                        path: '/moduleManage',
                        parentUuid:'13',
                    },
                    {
                        id: '131',
                        name: '签章管理',
                        url: '/signatureManage',
                        path: '/signatureManage',
                        parentUuid:'13',
                    },
                ],
            },
        ]
    },
    // {
    //     id: '2',
    //     icon: 'iconfont icon-shangpin',
    //     name: '模型',
    //     children: [
    //         // {
    //         //     id: '20',
    //         //     name: '我上传的',
    //         //     url: '/modelUpload'
    //         // },
    //         {
    //             id: '21',
    //             name: '我下载的',
    //             url: '/modelDownload'
    //         }
    //     ]
    // },
    {
        id: '7',
        icon: 'iconfont icon-shangpin',
        name: '需求',
        parentUuid:'',
        children: [
            {
                id: '71',
                name: '我发布的',
                url: '/demand',
                path: '/demand',
                parentUuid:'7',
            }
        ]
    },
    {
      id: '8',
      icon: 'el-icon-present',
      name: '活动',
      parentUuid:'',
      children: [
        {
          id: '80',
          name: '我的活动',
          url: '/activeJoin',
          path: '/activeJoin',
          parentUuid:'8',
        }
      ]
    },
    {
        id: '3',
        icon: 'iconfont icon-dianpu',
        name: '收藏',
        parentUuid:'',
        children: [
            {
                id: '30',
                name: '资讯',
                url: '/newsManagement',
                path: '/newsManagement',
                parentUuid:'3',
            },
            {
                id: '31',
                name: '需求',
                url: '/demandManagement',
                path: '/demandManagement',
                parentUuid:'3',
            },
            {
                id: '32',
                name: '模型',
                url: '/modelManagement',
                path: '/modelManagement',
                parentUuid:'3',
            },
            {
                id: '33',
                name: '服务',
                url: '/serveManagement',
                path: '/serveManagement',
                parentUuid:'3',
            },
            {
                id: '34',
                name: '商品',
                url: '/goodsManagement',
                path: '/goodsManagement',
                parentUuid:'3',
            },
            {
                id: '35',
                name: '软件',
                url: '/softwareManagement',
                path: '/softwareManagement',
                parentUuid:'3',
            },
        ]
    },
    {
        id: '4',
        icon: 'iconfont icon-diannao',
        name: '关注',
        parentUuid:'',
        children: [
            {
                id: '40',
                name: '服务商',
                url: '/serviceProviders',
                path: '/serviceProviders',
                parentUuid:'4',
            },
            {
                id: '41',
                name: '设计师',
                url: '/designerFocus',
                path: '/designerFocus',
                parentUuid:'4',
            },
        ]
    },
    {
        id: '5',
        icon: 'iconfont icon-yingxiaoguanli',
        name: '服务',
        parentUuid:'',
        children: [
            {
                id: '50',
                name: '售后服务',
                url: '/afterSalesService',
                path: '/afterSalesService',
                parentUuid:'5',
            },
            {
                id: '51',
                name: '我的投诉',
                url: '/myComplaint',
                path: '/myComplaint',
                parentUuid:'5',

            },
            {
                id: '52',
                name: '发票管理',
                parentUuid:'5',
                children: [
                    {
                        id: '500',
                        name: '我的发票',
                        url: '/myInvoice',
                        path: '/myInvoice',
                        parentUuid:'52',
                    },
                    {
                        id: '501',
                        name: '抬头管理',
                        url: '/invoiceManagement',
                        path: '/invoiceManagement',
                        parentUuid:'52',
                    },
                    // {
                    //     id: '502',
                    //     name: '收票地址',
                    //     url: '/addressManagement'
                    // },
                ]
            },
            {
                id: '53',
                name: '在线咨询',
                url: "/consultInfo",
                path: "/consultInfo",
                parentUuid:'5',
            },
            {
                id: '54',
                name: '站内信',
                url:'/stationMessageLog',
                path:'/stationMessageLog',
                parentUuid:'5',
            },
            {
                id: '55',
                name: '解决方案咨询',
                url:'/solutionConsult',
                path:'/solutionConsult',
                parentUuid:'5',
            },
        ]
    },
    {
        id: '6',
        icon: 'iconfont icon-shuju',
        name: '足迹',
        parentUuid:'',
        children: [
            {
                id: '60',
                name: '浏览记录',
                url: '/browsingHistory',
                path: '/browsingHistory',
                parentUuid:'6',
            },
        ]

    },
]



// WEBPACK FOOTER //
// ./src/utils/navList.js